package com.upcominds.expedite.dto

import com.upcominds.expedite.model.Challenge
import com.upcominds.expedite.model.ChallengeType
import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class ChallengeUpdateRequest(
    val name: String,
    val description: String,
    val imageUrl: String?,
    val imageFile: String?,
    val points: Int,
    val duration: Long,
    val deadline: LocalDateTime,
    val difficulty: Challenge.Difficulty,
    val type: ChallengeType,
    val contentId: String? = null,
    val savingsConfig: SavingsChallengeConfigCreateRequest? = null,
    val socialConfig: SocialChallengeConfigCreateRequest? = null
)
